jQuery(function ($) {
    var open = 'single-accordion--hidden';

    $('.faq-accordions__wrapper').each(function (accordionIndex, accordionElement) {
        var accordion = $(accordionElement);
        var questions = accordion.find('> dt');
        var answers = accordion.find('> dd');

        questions.each(function (questionIndex, questionElement) {
            var question = $(questionElement);
            var link = question.find('> a');
            var answer = question.next('dd');

            if (answer.length === 0) {
                return;
            }

            if (link.length === 0) {
                link = $('<a href="#">' + question.text() + '</a>');
                question.empty().append(link);
            }

            link.on('click', function (e) {
                e.preventDefault();

                answer.slideToggle().promise().done(function () {
                    question.toggleClass(open, answer.is(':visible'));
                });
            });
        });

        answers.hide();
        questions.removeClass(open);
    });
});